import React from 'react';
import MindMap from './variants/MindMap';
import './WorkflowUseCases.css';

const WorkflowUseCases = () => {
  return (
    <section className="wuc-section">
      <div className="wuc-grid">
        {/* Left: mind-map visual */}
        <div className="wuc-right">
          <MindMap />
        </div>

        {/* Right: title + cards */}
        <div className="wuc-left">
          <div className="wuc-eyebrow">One platform. Endless agents.</div>
          <h2 className="wuc-title">Anything you can graph.</h2>

          <div className="wuc-cards">
            <div className="wuc-card">
              <h3>Compose any task as a graph</h3>
              <p>
                Define nodes, pick the agent per step, get Zod-validated handoff between them.
                Mix Claude + Cursor + Codex + Gemini in one pipeline.
              </p>
            </div>

            <div className="wuc-card">
              <h3>Run anywhere</h3>
              <p>
                Develop locally with hot reload. Deploy to our cloud as Heroku-style bundles.
                Trigger from any CI/CD, webhook, or HTTP call.
              </p>
            </div>

            <div className="wuc-card">
              <h3>Start with browser testing</h3>
              <p>
                Browser testing is what we ship today. The same primitives power refactoring,
                migrations, code review, documentation, and anything else you can graph.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowUseCases;
